export default {
  email: 'Email',
  fullName: 'Emri i plotë',
  password: 'Fjalëkalimi',
  confirmPassword: 'Konfirmoni fjalëkalimin',
};
